module.exports = __webpack_public_path__ + "static/media/Fallecimiento4.c882a6c1.svg";